import axios from '../axiosInstance';
import { PaginatedResponse } from '../useApi';

export type Role = {
  name: string;
  description: string;
};

export type User = {
  id: number;
  username: string;
  first_name: string;
  last_name: string;
  email: string;
  is_active: boolean;
  roles: Role[];
};

export type UserWrite = {
  username: string;
  first_name?: string;
  last_name?: string;
  email?: string;
};

export const UserApi = () => ({
  getUser: () => axios.get<User>('/users/user/'),
  updateUser: (data: UserWrite) => axios.put<UserWrite>('/users/user/', data),
  patchUser: (data: Partial<UserWrite>) => axios.patch<UserWrite>('/users/user/', data),
  getUsers: () => axios.get<PaginatedResponse<User>>('/v1/users-view/'),
});
